module.exports = "/_next/static/images/UncoverKeyMoments@2x-90d8417f42c29e7042ee6894be8598df.webp";